import * as Sentry from '@sentry/react';

export function initSentry() {
  Sentry.init({
    dsn: 'https://14071a8a74609febe073a6850ca7fc96@o4510602904600576.ingest.us.sentry.io/4510643415285760',

    // Set the environment
    environment: import.meta.env.MODE,

    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    // Adjust this value in production to balance performance insights vs. costs
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.2 : 1.0,

    // Capture Replay for 10% of all sessions,
    // plus 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Production builds only, so local development doesn't send traces and replays.
    enabled: import.meta.env.PROD,

    // Ignore common non-actionable errors
    ignoreErrors: [
      // Network errors
      'Network Error',
      'Failed to fetch',
      'Load failed',
      'NetworkError',
      // Cancelled requests
      'AbortError',
      'canceled',
      // Browser extensions
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      // Resize observer errors (common, usually harmless)
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],

    // Filter out events from browser extensions
    beforeSend(event) {
      // Filter out errors from browser extensions
      if (event.exception?.values?.[0]?.stacktrace?.frames) {
        const frames = event.exception.values[0].stacktrace.frames;
        const isFromExtension = frames.some(
          (frame) =>
            frame.filename?.includes('chrome-extension://') ||
            frame.filename?.includes('moz-extension://')
        );
        if (isFromExtension) {
          return null;
        }
      }
      return event;
    },
  });
}

// Export Sentry for use in other parts of the app
export { Sentry };
